var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcViewLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ Globe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 10H6.66667M2.5 10C2.5 14.1421 5.85786 17.5 10 17.5M2.5 10C2.5 5.85786 5.85786 2.5 10 2.5M6.66667 10H13.3333M6.66667 10C6.66667 14.1421 8.15905 17.5 10 17.5M6.66667 10C6.66667 5.85786 8.15905 2.5 10 2.5M13.3333 10H17.5M13.3333 10C13.3333 5.85786 11.8409 2.5 10 2.5M13.3333 10C13.3333 14.1421 11.8409 17.5 10 17.5M17.5 10C17.5 5.85786 14.1421 2.5 10 2.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5",
    stroke: "#5E42E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewLang);
export default __webpack_public_path__ + "static/media/ic_view_lang.69a3e2d330fd7a2b984ff10d14ed4ca5.svg";
export { ForwardRef as ReactComponent };